export function leftpad(str, num) {
  str = '' + str;
  while (str.length < num) {
    str = '0' + str;
  }
  return str;
}

export function angleReflect(incidenceAngle, surfaceAngle) {
  let a = surfaceAngle * 2 - incidenceAngle;
  return a >= 360 ? a - 360 : a < 0 ? a + 360 : a;
}
